import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { Providers } from '@/providers';
import { router } from '@/routes';
import '@/styles/globals.css';

const container = document.getElementById('root');
if (!container) throw new Error('No #root element - check index.html');

createRoot(container).render(
  <StrictMode>
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  </StrictMode>,
);
